import { injectIntl } from 'react-intl';
import JourneySelection from './JourneySelection';

export default injectIntl(JourneySelection);
